/* eslint-disable-next-line import/no-cycle */
import { userAlertsCache } from './tasks';

import { UserSessionData } from '@api/gql/graphql';
import { setStorageItem } from '@src/utils/helperFunctions';
import { userAlertsVar, userCoordinatesVar, userSessionVar } from '@store/reactiveVars';
import { UserAlertsVar } from '@store/types';

export const updateUserSession = (dataPassed: UserSessionData) => {
  setStorageItem('userData', JSON.stringify(dataPassed));
  return userSessionVar(dataPassed);
};

export const updateUserAlerts = <K extends keyof UserAlertsVar>(
  alertKey: K,
  dataPassed: UserAlertsVar[K]
) => {
  userAlertsCache.set(alertKey, dataPassed as Partial<UserAlertsVar>);

  const updatedAlerts = Object.fromEntries(userAlertsCache);
  setStorageItem('userAlerts', updatedAlerts);
  userAlertsVar(updatedAlerts);
};

export const getStoredUserCoordinates = () => {
  const userCoordinates = sessionStorage.getItem('userCoordinates');
  return userCoordinates && JSON.parse(userCoordinates);
};

export const storeUserCoordinates = ({ latitude, longitude }: Partial<GeolocationCoordinates>) => {
  sessionStorage.setItem('userCoordinates', JSON.stringify({ latitude, longitude }));
  return userCoordinatesVar(getStoredUserCoordinates());
};
